import { request } from './request'

export interface GetTemplateList {
  keyword?: string
  limit: number
  page: number
  is_parsing?: number
  origin_type?: number
  file_format?: number
  resource_tag_ids?: string[]
}

export const getTemplateList = (data: GetTemplateList) =>
  request('/portal/verify/dataProtection/templateResourceList', {
    params: {
      ...data,
    },
  })

export const getTemplateFormat = () => request('/portal/verify/dataProtection/fileFormatList')

export interface AddTemplate {
  name: string
  file_type: number
  file_path?: string
  content?: string
  describe?: string
  items?: object
}

export const checkName = data =>
  request('/portal/verify/dataProtection/checkTemplateExists', {
    params: {
      ...data,
    },
  })

export const checkEditName = data =>
  request('/portal/verify/dataProtection/checkUpdateTemplateExists', {
    params: {
      ...data,
    },
  })
export const addTemplate = (data: AddTemplate) =>
  request('/portal/verify/dataProtection/createTemplate', {
    method: 'POST',
    data,
  })

export const getTemplateDetail = data =>
  request(`/portal/verify/dataProtection/templateResourceDetail/${data.id}`, {
    params: {
      ...data,
    },
  })

export const deleteTemplate = data =>
  request(`/portal/verify/dataProtection/deleteTemplateResource`, {
    method: 'DELETE',
    params: data,
  })

export const editTemplate = data =>
  request(`/portal/verify/dataProtection/updateTemplate`, {
    method: 'PUT',
    data,
  })
